<template>
    <ClientOnly>
        <VJoyIconButton variant="ghost" icon="add" size="small" :label="$t('general.add')" @click="openEducationsAddDialog" />
        <template #fallback>
            <SectionActionSkeleton />
        </template>
    </ClientOnly>
</template>

<script setup lang="ts">
    import {VJoyIconButton} from '@maltjoy/core-vue';
    import SectionActionSkeleton from '~/components/section/SectionActionSkeleton.vue';
    import {eventBus} from '~/config/events';
    import {EditionOpenedEntryPoint} from '~/config/TrackingEvents';

    function openEducationsAddDialog() {
        eventBus.emit('educations:add-mode', {entryPoint: EditionOpenedEntryPoint.PROFILE_PAGE});
    }
</script>
